var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function rgbToHSL(r, g, b) {
    // Normaliser les valeurs RGB (entre 0 et 1)
    r /= 255;
    g /= 255;
    b /= 255;
    var Cmax = Math.max(r, g, b);
    var Cmin = Math.min(r, g, b);
    var delta = Cmax - Cmin;
    var h = 0;
    var s = 0;
    var l = (Cmax + Cmin) / 2;
    // Calcul de la teinte (Hue)
    if (delta !== 0) {
        if (Cmax === r) {
            h = (g - b) / delta;
        }
        else if (Cmax === g) {
            h = (b - r) / delta + 2;
        }
        else {
            h = (r - g) / delta + 4;
        }
        h *= 60;
        if (h < 0)
            h += 360; // Ajouter 360 si négatif
    }
    // Calcul de la saturation
    if (delta !== 0) {
        if (l < 0.5) {
            s = delta / (Cmax + Cmin);
        }
        else {
            s = delta / (2 - Cmax - Cmin);
        }
    }
    // Calcul de la luminance
    s = s * 100;
    l = l * 100;
    // Retourner un objet avec h, s et l
    return { h: Math.round(h), s: Math.round(s), l: Math.round(l) };
}
export function getColorBaseRGB(baseColor, shade) {
    var colorKey = "".concat(baseColor, "-").concat(shade);
    var color = getComputedStyle(document.documentElement).getPropertyValue("--color-".concat(colorKey));
    if (!color)
        return null;
    var _a = color.trim().split(" ").map(Number), r = _a[0], g = _a[1], b = _a[2];
    return { r: r, g: g, b: b };
}
/**
 * <b>Fonction qui convertit une couleur CSS (en format RGB ou autre) en une valeur HSL.
 * Elle extrait les valeurs RGB de la couleur, puis les convertit en teinte (H), saturation (S) et luminosité (L).</b>
 *
 */
export function cssColorToHSL(cssColor) {
    // Créer un élément temporaire pour obtenir la valeur calculée de la couleur
    var temp = document.createElement("div");
    temp.style.color = cssColor;
    document.body.appendChild(temp);
    var computedColor = getComputedStyle(temp).color;
    document.body.removeChild(temp);
    // Extraire les valeurs RGB
    var match = computedColor === null || computedColor === void 0 ? void 0 : computedColor.match(/\d+/g);
    var r = match && parseInt(match[0]) / 255;
    var g = match && parseInt(match[1]) / 255;
    var b = match && parseInt(match[2]) / 255;
    // Convertir RGB en HSL
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max === min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [h * 360, s * 100, l * 100];
}
export function HSLToRGB(h, s, l) {
    var r, g, b;
    if (s === 0) {
        r = g = b = l;
    }
    else {
        var hue2rgb = function (p, q, t) {
            if (t < 0)
                t += 1;
            if (t > 1)
                t -= 1;
            if (t < 1 / 6)
                return p + (q - p) * 6 * t;
            if (t < 1 / 2)
                return q;
            if (t < 2 / 3)
                return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}
export function HSLToHex(h, s, l) {
    l /= 100;
    var a = (s * Math.min(l, 1 - l)) / 100;
    var f = function (n) {
        var k = (n + h / 30) % 12;
        var color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0");
    };
    return "#".concat(f(0)).concat(f(8)).concat(f(4));
}
//startColor base de couleur
export function generateGoldenRatioColors(numColors, startColor) {
    var colors = [];
    var goldenRatioConjugate = 0.618033988749895;
    var hue = cssColorToHSL(startColor)[0] / 360;
    for (var i = 0; i < numColors; i++) {
        hue += goldenRatioConjugate;
        hue %= 1;
        var rgb = HSLToRGB(hue, 0.5, 0.6);
        colors.push("#".concat(rgb.map(function (x) { return x.toString(16).padStart(2, "0"); }).join("")));
    }
    return colors;
}
export function generateHSLBasedColors(numColors, startColor) {
    var colors = [];
    var _a = cssColorToHSL(startColor), startHue = _a[0], startSat = _a[1], startLig = _a[2];
    var hueStep = 360 / numColors;
    for (var i = 0; i < numColors; i++) {
        var hue = (startHue + i * hueStep) % 360;
        var sat = Math.min(100, startSat + i * 5);
        var lig = Math.max(20, startLig - i * 3);
        colors.push(HSLToHex(hue, sat, lig));
    }
    return colors;
}
export function generatePastelColors(numColors, startColor) {
    var colors = [];
    var _a = cssColorToHSL(startColor), startHue = _a[0];
    var hueStep = 360 / numColors;
    for (var i = 0; i < numColors; i++) {
        var hue = (startHue + i * hueStep) % 360;
        colors.push(HSLToHex(hue, 50 + Math.random() * 20, 80 + Math.random() * 10));
    }
    return colors;
}
export function generateAnalogousColors(numColors, startColor) {
    var colors = [];
    var _a = cssColorToHSL(startColor), startHue = _a[0], startSaturation = _a[1], startLightness = _a[2];
    var hueStep = 30 / numColors; // On prend un petit intervalle autour de la couleur de départ
    for (var i = 0; i < numColors; i++) {
        var hue = (startHue + i * hueStep - 15) % 360; // Distribution autour de la couleur de départ
        colors.push(HSLToHex(hue, startSaturation, startLightness));
    }
    return colors;
}
export function generateComplementaryColors(numColors, startColor) {
    var colors = [];
    var _a = cssColorToHSL(startColor), startHue = _a[0], startSaturation = _a[1], startLightness = _a[2];
    var complementaryHue = (startHue + 180) % 360; // Couleur opposée sur le cercle chromatique
    for (var i = 0; i < numColors; i++) {
        var hue = i % 2 === 0 ? startHue : complementaryHue; // Alterne entre couleur de départ et complémentaire
        colors.push(HSLToHex(hue, startSaturation, startLightness));
    }
    return colors;
}
export function generateTriadicColors(numColors, startColor) {
    var colors = [];
    var _a = cssColorToHSL(startColor), startHue = _a[0], startSaturation = _a[1], startLightness = _a[2];
    // Calcul des trois teintes triadiques
    var triadicHues = [
        startHue,
        (startHue + 120) % 360,
        (startHue + 240) % 360,
    ];
    // Alterne entre ces trois teintes
    for (var i = 0; i < numColors; i++) {
        var hue = triadicHues[i % 3];
        colors.push(HSLToHex(hue, startSaturation, startLightness));
    }
    return colors;
}
export function generateMonochromaticColors(numColors, startColor) {
    var _a = cssColorToHSL(startColor), h = _a[0], s = _a[1], l = _a[2];
    var colors = [];
    for (var i = 0; i < numColors; i++) {
        var newL = Math.max(0, Math.min(100, l - 50 + (i * 100) / (numColors - 1)));
        //colors.push(`hsl(${h}, ${s}%, ${newL}%)`);
        colors.push(HSLToHex(h, s, newL));
    }
    return colors;
}
export function generateSequentialColors(numColors, startColor, endColor) {
    var _a = cssColorToHSL(startColor), h1 = _a[0], s1 = _a[1], l1 = _a[2];
    var _b = cssColorToHSL(endColor), h2 = _b[0], s2 = _b[1], l2 = _b[2];
    var colors = [];
    for (var i = 0; i < numColors; i++) {
        var factor = i / (numColors - 1);
        var h = h1 + (h2 - h1) * factor;
        var s = s1 + (s2 - s1) * factor;
        var l = l1 + (l2 - l1) * factor;
        //colors.push(`hsl(${h}, ${s}%, ${l}%)`);
        colors.push(HSLToHex(h, s, l));
    }
    return colors;
}
export function generateDivergingColors(numColors, startColor, midColor, endColor) {
    /*const halfColors = Math.ceil(numColors / 2);
    const firstHalf = generateSequentialColors(halfColors, startColor, midColor);
    const secondHalf = generateSequentialColors(halfColors, midColor, endColor);
    return [...firstHalf, ...secondHalf.slice(1)].slice(0, numColors);*/
    var firstHalfCount = Math.floor(numColors / 2);
    var secondHalfCount = numColors - firstHalfCount; // Assure un total exact
    var firstHalf = generateSequentialColors(firstHalfCount, startColor, midColor);
    var secondHalf = generateSequentialColors(secondHalfCount, midColor, endColor);
    return __spreadArray(__spreadArray([], firstHalf, true), secondHalf, true);
}
export function rgbToHex(r, g, b) {
    return "#".concat(((1 << 24) | (r << 16) | (g << 8) | b)
        .toString(16)
        .slice(1)
        .toUpperCase());
}
export var colorStartHexa = function (colorBase, shadeValue) {
    var rgb = getColorBaseRGB(colorBase, shadeValue);
    var _a = rgb !== null && rgb !== void 0 ? rgb : {}, _b = _a.r, r = _b === void 0 ? 0 : _b, _c = _a.g, g = _c === void 0 ? 0 : _c, _d = _a.b, b = _d === void 0 ? 0 : _d;
    return rgbToHex(r, g, b);
};
/*export function generateDistinctColors(
  numColors: any,
  shade: any,
  colorBase: any,
  algorithm: any,
  endColor: any,
  midColor: any
) {
  let colors;
  const startColor = colorStartHexa(colorBase, shade);
  switch (algorithm) {
    case "goldenRatio":
      colors = generateGoldenRatioColors(numColors, startColor);
      break;
    case "hslBased":
      colors = generateHSLBasedColors(numColors, startColor);
      break;
    case "pastel":
      colors = generatePastelColors(numColors, startColor);
      break;
    case "analogous":
      colors = generateAnalogousColors(numColors, startColor);
      break;
    case "complementary":
      colors = generateComplementaryColors(numColors, startColor);
      break;
    case "triadic":
      colors = generateTriadicColors(numColors, startColor);
      break;
    case "monochromatic":
      colors = generateMonochromaticColors(numColors, startColor);
      break;
    case "sequential":
      colors = generateSequentialColors(
        numColors,
        startColor,
        endColor || "#FFFFFF"
      );
      break;
    case "diverging":
      colors = generateDivergingColors(
        numColors,
        startColor,
        midColor || "#FFFFFF",
        endColor || "#000000"
      );
      break;
    default:
      colors = generateGoldenRatioColors(numColors, startColor);
  }
  return colors;
}*/
